/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

export function invoiceAmount (amount) {
  let result = amount * -1

  if (result === 0) {
    result = 0
  }
  return result
}

/**
 * Returns a transaction with inverse amounts.
 * @param transaction {Partial<Transaction>}
 * @returns {Partial<Transaction>}
 */
export function inverseAmounts (transaction) {
  const result = { ...transaction };
  [
    'amount',
    'cps',
    'vat',
    'total'
  ].forEach((attr) => {
    if (typeof result[attr] === 'number') {
      result[attr] *= -1
    }
  })
  return result
}
